import React from "react";

import Marker from "./Marker";

import "./styles.scss";

/** --------------------------------------------------------------------------------------
 * Example of marker data
 *
 * @props : "markerData" is the array of objects of the form `{ status: 'done', caption: 'yyyy'}`
 * @props : "slide" is a boolean (not in implementaion right now)
 *
 *
 * Example of markerData
 * markerData = [
 *      { status: 'done', caption: 'Start Assessment' },
 *      { status: 'active', caption: 'Schedule Video Consult' },
 *      { status: 'default', caption: 'Initial Video Consult' },
 *  ]
 *
 * Note: There are as of now three 'status' namely "done", "active", "default"
 *
 *--------------------------------------------------------------------------------------*/

const ProgressSlider = (props) => {
  let { markerData, slide } = props;

  return (
    <>
      {!props.WithNavigationArrow && (
        <div className="d-flex w-100 mx-auto tw:justify-center">
          {markerData.map((marker, i) => {
            switch (i) {
              case 0:
                return <Marker caption={marker.caption} hideStart key={i} status={marker.status} />;

              case markerData.length - 1:
                return <Marker caption={marker.caption} hideEnd key={i} status={marker.status} />;

              default:
                return <Marker caption={marker.caption} key={i} status={marker.status} />;
            }
          })}
        </div>
      )}
      {props.WithNavigationArrow && (
        <div className="ProgressSlider__Navigator d-flex w-100 mx-auto tw:justify-center">
          {markerData.map((marker, i) => {
            return <Marker caption={marker.caption} index={i} key={i} status={marker.status} />;
          })}
        </div>
      )}
    </>
  );
};

export default ProgressSlider;
